module.exports = __webpack_public_path__ + "img/72.10c36085.gif";